import React, {Component, Fragment} from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import { ButtonContained } from '../app-button/button'
import Spinner from '../spinner'
import renderSelectField from './field/customSelect'
import renderMultipleSelectField from './field/customMultipleSelect'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import renderHTML from 'react-render-html';

const styles = theme => ({
  form: {
    maxWidth: 340,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  crmDescriptionSmall: {
    marginTop: '20px',
    marginBottom: '5px',
    opacity: '0.75',
    fontSize: '12px',
    whiteSpace: 'pre-line',
  },
  error: {
    padding: '10px 0',
    fontSize: '12px',
    color: '#ff4e44',
  },
  hidden: {
    display: 'none',
  },
  link2: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    textDecoration: 'underline',
  },
  fieldGroup: {
    position: 'relative',
  },
  hintIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    display: 'block',
    width: 24,
    height: 24,
    border: '1px solid rgb(136, 102, 255)',
    borderRadius: '50%',
    lineHeight: '22px',
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: 'rgb(136, 102, 255)',
    transform: 'translateX(50px)',
    textAlign: 'center',
  },
  hintHelp: {
    textAlign: 'left',
    padding: '4px 8px',
  },
})

class UonCrmForm2 extends Component {
  state = {
    destination: null,
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  handleChangeDestination = event => {
    this.setState({ destination: event.target.value })
  }

  render() {
    const {
      classes,
      handleSubmit,
      submitFailed,
      invalid,
      error,
      isFetching,
    } = this.props

    if (
      state.account.import_destination &&
      state.account.import_destination == 'ecom'
    ) {
      this.state.destination = state.account.import_destination
    }

    const menuItem = item => {
      return (
        <MenuItem value={item.id} key={item.id}>
          {renderHTML(item.name)}
        </MenuItem>
      )
    }

    const fields = () => {
      let list = []

      for (let i in state.availableFields) {
        list.push(menuItem(state.availableFields[i]))
      }

      return list
    }

    const stages = () => {
      let list = []

      for (let i in state.availableStages) {
        list.push(menuItem(state.availableStages[i]))
      }

      return list
    }

    const destinations = () => {
      let list = []

      for (let i in state.destinations) {
        list.push(menuItem(state.destinations[i]))
      }

      return list
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.crmDescriptionSmall}>
          Выберите, куда хотите отправлять данные
        </div>
        <div className={classes.fieldGroup}>
          <Field
            name="destination"
            component={renderSelectField}
            onChange={this.handleChangeDestination}
          >
            <MenuItem value="">
              <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                Выберите, куда хотите отправлять данные
              </span>
            </MenuItem>
            {destinations()}
          </Field>
          <Tooltip
            interactive
            disableFocusListener
            PopperProps={{
              disablePortal: true,
            }}
            classes={{
              tooltip: classes.hint,
              popper: classes.popper,
            }}
            title={
              <Fragment>
                <div className={classes.hintHelp}>
                  <p>
                    Отправка данных в Электронную торговлю позволяет передавать
                    дополнительные данные: Название товара/услуги, количество,
                    цену, передавать данные о возвратах и другое.
                  </p>
                  <p>
                    Отправка данных в цель позволяет передать только количество
                    и сумму продаж.
                  </p>
                </div>
              </Fragment>
            }
          >
            <span className={classes.hintIcon}>?</span>
          </Tooltip>
        </div>

        <div className={classes.crmDescriptionSmall}>
          Выберите статусы <b>Успешной сделки</b>
        </div>
        <Field name="pipeline" component={renderMultipleSelectField}>
          <MenuItem value="" style={{ display: 'none' }}>
            <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
              Выберите статусы продажаж
            </span>
          </MenuItem>
          {stages()}
        </Field>

        {this.state.destination == 'ecom' || this.state.destination == null ? (
          <div>
            <div className={classes.crmDescriptionSmall}>
              Выберите статус возврата
            </div>
            <Field name="cancel_status" component={renderSelectField}>
              <MenuItem value="" style={{ display: 'none' }}>
                <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                  Выберите статус возврата
                </span>
              </MenuItem>
              {stages()}
            </Field>
          </div>
        ) : (
          <div className={classes.hidden}>
            <div className={classes.crmDescriptionSmall}>
              Выберите статус <b>Возврата</b>
            </div>
            <Field name="cancel_status" component={renderSelectField}>
              <MenuItem value="" style={{ display: 'none' }}>
                <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                  Выберите статус <b>Возврата</b>
                </span>
              </MenuItem>
              {stages()}
            </Field>
          </div>
        )}

        <div
          style={{ marginBottom: '15px' }}
          className={classes.crmDescriptionSmall}
        >
          Google client id должен быть записан в поле Примечание в формате
          GA.1.2.XXXXXXXX.XXXXXXXX.{'\n'}
          Обычно он выглядит вот так: GA.1.2.532344565.4267554223{'\n'}
          Подробнее о том, как передавать Google client id, читайте в{' '}
          <a
            className={classes.link2}
            href="https://cabinet.romi.center/help/podklyuchenie-uon-travel-crm"
            target="_blank"
          >
            инструкции
          </a>{' '}
          {'\n'}
        </div>

        {error ? <div className={classes.error}>{error}</div> : ''}
        <ButtonContained
          style={{
            flexShrink: 0,
            fontSize: 16,
            width: '100%',
            height: 48,
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={isFetching ? <Spinner /> : 'Подключить'}
        />
      </form>
    )
  }
}

UonCrmForm2 = reduxForm({
  form: 'UonCrmForm2',
})(UonCrmForm2)

export default withStyles(styles)(UonCrmForm2)
